<template>
  <footer
    class="form-fw__footer"
    :class="{ 'form-fw__footer--shadow': shadow }"
  >
    <div class="form-fw__footer__container py-2">
      <div class="text-xs-right">
        <a
          v-if="status !== isLoading"
          href="#"
          :title="$t('Common.cancel')"
          class="accent--text mr-2"
          @click.prevent="cancel"
        >{{ $t('Common.cancel') }}</a>

        <v-btn
          :disabled="status === isLoading"
          :loading="status === isLoading"
          type="submit"
          color="accent"
          depressed
          round
          @click="submit"
        >
          {{ $t(`${namespace}.submitButtonLabel`) }}
        </v-btn>
      </div>
    </div>
  </footer>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { goBack } from '@/utils/functions'

export default {
  name: 'EmployeeMassCreditPolicyFooter',
  props: {
    kind: {
      type: String
    },
    status: {
      type: Number
    }
  },
  computed: {
    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED
  },
  data () {
    return {
      namespace: 'Views.EmployeeMassCreditPolicyPage',
      shadow: true
    }
  },
  methods: {
    cancel () {
      goBack()
    },

    submit () {
      this.$emit('submit')
    },

    handleShadow () {
      this.shadow = !((window.innerHeight + window.scrollY) >= document.body.offsetHeight)
    }
  },
  mounted () {
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
  }
}
</script>
